import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
  opacity: 0.5;
  cursor: not-allowed;
`;

export default Wrapper(template);
